const Module2Config = {
	day1: {
		learn: {
			video: '0923fa9139536dad2971b70ea902/480.m3u8',
			song: 'appfiles/listening/school_photo_montage_music_1.m4a',
			json: 'appfiles/listening/school_photo_montage_data_1.json',
		},
		celebrate: {
			video: '240ad10d09d32337c2de0b74eba6/480.m3u8',
		},
		rewardOption2: 'MonkeybarsYellow',
		rewardOption1: 'MonkeybarsBlue',
	},
	day2: {
		learn: {
			video: '86df5b034e90e878b815ffda106b/480.m3u8',
			song: 'appfiles/listening/school_photo_montage_music_2.m4a',
			json: 'appfiles/listening/school_photo_montage_data_2.json',
		},
		celebrate: {
			video: '31586dd403d5d3abdb8d1cf3bdf7/480.m3u8',
		},
		rewardOption2: 'SlideYellow',
		rewardOption1: 'SlideRed',
	},
	day3: {
		learn: {
			video: '6b1ccc13df3d3df9dfe69649805d/480.m3u8',
			song: 'appfiles/listening/school_photo_montage_music_3.m4a',
			json: 'appfiles/listening/school_photo_montage_data_3.json',
		},
		celebrate: {
			video: '01775cec411a547551c7653274ac/480.m3u8',
		},
		rewardOption1: 'Pond',
		rewardOption2: 'Sandbox',
	},
	day4: {
		introVideo: '8de031ec00e23dcc3872ec2280ac/480.m3u8',
		rewardOption2: 'KitePink',
		rewardOption1: 'KitePurple',
		photoTime: {
			video1: 'facb8e1db7aaf3206c4dc3ccbda5/480.m3u8',
			video2: '3553caab0e3822e873470a27f023/480.m3u8',
		},
		singingTime: {
			intro: 'f63e98b94609f5de3c6fc8392da4/480.m3u8',
			demoMusic: '',
			singAlongMusic: 'appfiles/listening/listening_student_singalong.m4a',
			instrumentalMusic:
				'appfiles/listening/listening_student_instrumental.m4a',
			singingAlongVideo: 'appfiles/listening/singingtime_listening_demo.mp4',
			instrumentalVideo: 'appfiles/listening/singingtime_listening_karaoke.mp4',
		},
	},
	day5: {
		introVideo: 'b1bccc9f9711f1920827ae3b7fb8/480.m3u8',
		rewardOption1: 'TireSwing',
		rewardOption2: 'SpringToy',
		learn: {
			recording: 'userfiles/{student-id}/listening_play_day_music.m4a',
			video: 'influencers/{influencer-id}/answer_affirmation.mp4',
			song: 'appfiles/listening/listening_student_instrumental.m4a',
			demoSong: 'appfiles/listening/listening_student_singalong.m4a',
			json: 'appfiles/listening/school_photo_montage_data_5.json',
		},
		celebrate: {
			video: '44b642e71d9f8b5d832f891b3917/480.m3u8',
			afterVideo: 'ae9af07b3c3df31d0db249192c64/480.m3u8',
			animal: true,
			text: 'Record yourself in an excited voice and say, "I am amazing!"',
			name: 'listening_celebration_surprise_5.mp4',
		},
	},
	day6: {
		rewardOption2: 'Flowers',
		rewardOption1: 'Ball',
		learn: {
			recording: 'userfiles/{student-id}/listening_play_day_music.m4a',
			video: 'influencers/{influencer-id}/answer_affirmation.mp4',
			song: 'appfiles/listening/listening_student_instrumental.m4a',
			demoSong: 'appfiles/listening/listening_student_singalong.m4a',
			json: 'appfiles/listening/school_photo_montage_data_6.json',
		},
		celebrate: {
			video: '21b9c2a4dab76b89d1290c9aa848/480.m3u8',
			afterVideo: '687f0a0a28eb57eae48ee8f09f97/480.m3u8',
			animal: true,
			text: 'Record yourself in a funny voice and say, "I am amazing!"',
			name: 'listening_celebration_surprise_6.mp4',
		},
	},
	day7: {
		rewardOption2: 'MerryGoRound',
		rewardOption1: 'Swingset',
		learn: {
			recording: 'userfiles/{student-id}/listening_play_day_music.m4a',
			video: 'influencers/{influencer-id}/answer_affirmation.mp4',
			song: 'appfiles/listening/listening_student_instrumental.m4a',
			demoSong: 'appfiles/listening/listening_student_singalong.m4a',
			json: 'appfiles/listening/school_photo_montage_data_7.json',
		},
		celebrate: {
			video: '1ab05bf4758cc6a8d747bc76203d/480.m3u8',
			afterVideo: '31c757005bf05b9e0b953bb1996b/480.m3u8',
			animal: true,
			text: 'Record yourself singing, "I am amazing!"',
			name: 'listening_celebration_surprise_7.mp4',
		},
	},
	day8: {
		rewardOption2: 'ButterflyBlue',
		rewardOption1: 'ButterflyPink',
		learn: {
			recording: 'userfiles/{student-id}/listening_play_day_music.m4a',
			video: 'influencers/{influencer-id}/answer_affirmation.mp4',
			song: 'appfiles/listening/listening_student_instrumental.m4a',
			demoSong: 'appfiles/listening/listening_student_singalong.m4a',
			json: 'appfiles/listening/school_photo_montage_data_8.json',
		},
		celebrate: {
			video: '533702866abfe8c6dfe200363d9a/480.m3u8',
			afterVideo: 'af53fa5caee85c7080a22ad5d7fb/480.m3u8',
			animal: true,
			text: 'Record yourself making a silly face and say, "I am amazing!"',
			name: 'listening_celebration_surprise_8.mp4',
		},
	},
	day9: {
		conclusionVideo: '9b862567ecb61c5aeaf4fe5cea1b/480.m3u8',
		rewardOption2: 'Hat',
		rewardOption1: 'Bow',
		learn: {
			video: 'influencers/{influencer-id}/answer_affirmation.mp4',
			song: 'appfiles/listening/listening_student_instrumental.m4a',
			recording: 'userfiles/{student-id}/listening_play_day_music.m4a',
			demoSong: 'appfiles/listening/listening_student_singalong.m4a',
			json: 'appfiles/listening/school_photo_montage_data_9.json',
		},
		celebrate: {
			video: 'ecd883dbe895c23a3ffbd46559a4/480.m3u8',
			afterVideo: null,
			animal: true,
			text: 'Record yourself dancing and say, "I am amazing!"',
			name: 'listening_celebration_surprise_9.mp4',
		},
		surprise: {
			video: '46bd04df8bf8e01c34daf3644c31/480.m3u8',
			song: 'appfiles/listening/hear_me_instrumental.m4a',
			slides: [
				'influencers/{influencer-id}/answer_affirmation.mp4',
				'userfiles/{student-id}/listening_celebration_surprise_6.mp4',
				'userfiles/{student-id}/listening_photo_1.jpg',
				'influencers/{influencer-id}/listening_video_message.mp4',
				'userfiles/{student-id}/listening_celebration_surprise_8.mp4',
				'userfiles/{student-id}/listening_silly_photo_2.jpg',
				'userfiles/{student-id}/listening_celebration_surprise_9.mp4',
			],
		},
	},
}

export default Module2Config
